module.exports = __webpack_public_path__ + "img/error.ebe4463a.svg";